import React, { useState } from "react";
import { isValidMac } from "../utils/validacionMac"; // Función en utils

function InputMac({ label, placeholder, title, value, onChange }) {
    const [mac, setMac] = useState(value || "");

    const handleChange = (e) => {
        let input = e.target.value.toUpperCase(); // Forzar mayúsculas
        input = input.replace(/[^0-9A-F]/g, ""); // Solo hexadecimales

        // Insertar ":" cada 2 caracteres
        let formatted = "";
        for (let i = 0; i < input.length; i++) {
            if (i > 0 && i % 2 === 0 && i < 12) {
                formatted += ":";
            }
            formatted += input[i];
        }

        setMac(formatted);
        if (onChange) onChange(formatted);
    };

    return (
        <div className="input-mac">
            {label && <label>{label}</label>}
            <input
                type="text"
                value={mac}
                onChange={handleChange}
                maxLength={17} // AA:BB:CC:DD:EE:FF para mac completa
                placeholder={placeholder || "AA:BB:CC:DD:EE:FF"}
                title={title}
            />
            {!isValidMac(mac) && mac.length > 0 && (
                <small style={{ color: "red" }}>Formato inválido</small>
            )}
        </div>
    );
}

export default InputMac;